module.exports = __webpack_public_path__ + "static/scale-model-of-acsailingsf,-inc.-in-berkeley-california-c2c6c7e49920b2b136b15956ee60d728.png";